const parseFilenameFromContentDisposition = (headerValue) => {
  if (!headerValue) return null;

  const utf8Match = headerValue.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch {
      return utf8Match[1];
    }
  }

  const asciiMatch = headerValue.match(/filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i);
  const filename = asciiMatch?.[1] || asciiMatch?.[2];
  return filename ? filename.trim() : null;
};

const buildFallbackFilename = (job, blobType) => {
  const baseName = job?.sora_id || 'video';
  const extension = blobType?.includes('mp4') ? 'mp4' : 'bin';
  return `${baseName}.${extension}`;
};

export const downloadJobResult = async (job) => {
  if (!job?.result_url) {
    throw new Error('Missing result_url');
  }

  const response = await fetch(job.result_url);
  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}`);
  }

  const blob = await response.blob();
  const filename =
    parseFilenameFromContentDisposition(response.headers.get('content-disposition')) ||
    buildFallbackFilename(job, blob.type);

  const objectUrl = window.URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    window.URL.revokeObjectURL(objectUrl);
  }
};
